// src/styles/displayPageStyles.js
import { styled } from 'baseui/styles';
import { HeadingLarge as BaseHeadingLarge, ParagraphSmall } from 'baseui/typography';

export const defaultAdHeight = '90px';
export const mobileAdHeight = '50px';
export const mobileLandscapeMaxHeight = '500px';

// DisplayPage全体のコンテナ
export const DisplayPageContainer = styled('div', ({ $theme, $palette }) => ({
  display: 'grid',
  gridTemplateRows: 'auto 1fr',
  height: '100%',
  backgroundColor: $palette.backgroundSecondary,
  color: $palette.contentPrimary,
  overflow: 'hidden',
}));

// 広告エリア
export const AdArea = styled('div', ({ $theme, $palette }) => ({
  height: defaultAdHeight,
  width: '100%',
  backgroundColor: $palette ? $palette.backgroundSecondary : $theme.colors.backgroundTertiary,
  color: $palette ? $palette.contentPrimary : $theme.colors.contentSecondary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '16px',
  flexShrink: 0,
  [`@media screen and (max-width: ${$theme.breakpoints.medium - 1}px), screen and (min-width: ${$theme.breakpoints.medium}px) and (max-width: ${$theme.breakpoints.large - 1}px) and (orientation: portrait)`]: {
    height: mobileAdHeight,
  },
  [`@media screen and (orientation: landscape) and (max-height: ${mobileLandscapeMaxHeight})`]: {
    height: mobileAdHeight,
  },
}));

export const LoadingContainer = styled('div', ({ $theme, $palette }) => ({
  height: '100dvh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: $palette?.backgroundPrimary || '#000',
  color: $palette?.contentPrimary || '#fff',
}));

export const LoadingText = styled(BaseHeadingLarge, ({ $theme, $palette }) => ({
  color: $palette?.contentPrimary || '#fff',
  marginLeft: $theme.sizing.scale600,
}));

export const OverlayContainer = styled('div', ({ $theme, $palette }) => ({
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100vw',
  height: '100vh',
  backgroundColor: $palette.backgroundPrimary,
  color: $palette.contentPrimary,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: '9999',
  padding: $theme.sizing.scale800,
  boxSizing: 'border-box',
}));

export const OverlayContent = styled('div', ({ $theme, $palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: $theme.sizing.scale600,
}));

export const OverlayHeader = styled('h2', ({ $theme, $palette }) => ({
  color: $palette.contentPrimary,
  marginBottom: $theme.sizing.scale400,
}));

export const OverlayInputOverrides = {
  Root: {
    style: ({ $theme }) => ({
      width: '300px',
    }),
  },
};

export const ErrorText = styled(ParagraphSmall, ({ $theme }) => ({
    color: $theme.colors.negative,
    marginTop: `-${$theme.sizing.scale400}`,
    marginBottom: `-${$theme.sizing.scale200}`,
    textAlign: 'center',
    maxWidth: '300px',
}));